import { camelizeKeys } from 'humps'
import { useGet, UseGetProps } from 'restful-react'
import { getApiUrl } from 'utils/api/apiHelpers'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'

export interface IGetSetupGuideParams {}

export type TSetupGuideStepType =
  | 'create_load'
  | 'invite_team_members'
  | 'carrier_onboarding'
  | 'connect_eld'
export type TSetupGuideStepStatus = 'not_started' | 'complete' | 'incomplete'

export interface ISetupGuideStep {
  type: TSetupGuideStepType
  status: TSetupGuideStepStatus
}

export interface IGetSetupGuideResponse {
  setupGuide: {
    steps: ISetupGuideStep[]
    dismissed: boolean | null
  }
}

export type IUseGetSetupGuideProps = Omit<
  UseGetProps<IGetSetupGuideResponse, unknown, void, IGetSetupGuideParams>,
  'path'
> &
  IGetSetupGuideParams

/**
 * Gets driver location paths for a shipment
 */
export const useGetSetupGuide = ({ ...props }: IUseGetSetupGuideProps) =>
  useGet<IGetSetupGuideResponse, unknown, void, IGetSetupGuideParams>(
    `/${FP_ENDPOINTS.setupGuide}`,
    /**
     * Override the `base` prop with stark __API__ string
     */
    {
      base: getApiUrl('FMS'),
      resolve: res => (camelizeKeys(res) as unknown) as IGetSetupGuideResponse,
      ...props,
    }
  )
